import "@fontsource/barlow";
import "@fontsource/barlow/700.css";
import "@fontsource/barlow/400-italic.css";

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
